import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BRAND_LOGO from '../images/home-logo.png';
import Card1 from '../images/Card1.png';
import Card2 from '../images/Card2.png';
import { webURL, card1Text, card2Text } from '../config';

import SideBar from '../generic_components/SideBar/SideBar';
import FOOTER_LOGO from '../images/RoninIconSmall.png';
import { fetchUser } from '../redux/actions/fetchUser';
import { useLocation } from "react-router-dom";

// import AdminIcon from '../images/Admin.svg';
import HealthInfoIcon from '../images/Health Info.png';
import ReportingIcon from '../images/Reporting.png';
import LifecycleIcon from '../images/Lifecycle.png';
import UserManagementIcon from '../images/User Management.png';
import AdminIcon from '../images/Admin.png';
import SiteIcon from '../images/Sites.png';
import LicenseIcon from '../images/Licenses.png';
import ResourcesIcon from '../images/Resources.png';

const SideBarNew = () => {

    const rbacGlobalData = useSelector((state) => state.rbacDataFromRedux);
    const fetchUserResponse = useSelector((state) => state.fetchUserResponse);

    // get the heights priority role for fetchUserResponse
    const ROLE_PRIORITY = ['TECHNICIAN', 'SUPERVISOR', 'ADMIN', 'TLA'];
    const LOWEST_ROLE = 'TECHNICIAN';

    function getEffectiveRole(fetchUserResponse) {
  // 1. Prefer global role if present
  const globalRole = fetchUserResponse?.role;
  if (ROLE_PRIORITY.includes(globalRole)) {
    return globalRole.toLowerCase();
  }

  // 2. Collect valid business roles
  const businessRoles =
    fetchUserResponse?.businesses
      ?.map(b => b?.role)
      .filter(r => ROLE_PRIORITY.includes(r)) ?? [];

  // 3. Reduce to highest priority role
  const highestRole = businessRoles.reduce((highest, role) => {
    return ROLE_PRIORITY.indexOf(role) >
      ROLE_PRIORITY.indexOf(highest)
      ? role
      : highest;
  }, LOWEST_ROLE);

  // 4. Normalize
  return highestRole.toLowerCase();
}

const effectiveRole = getEffectiveRole(fetchUserResponse);
if (effectiveRole) {
  localStorage.setItem('rbac_role', effectiveRole);
}

    const dispatch = useDispatch();

    const userEmail = localStorage.getItem('email');
    const location = useLocation();

    useEffect(() => {
        const fetchData = () => {
            dispatch(fetchUser(userEmail));
        };
        fetchData();
        const intervalId = setInterval(fetchData, 60000);
        return () => clearInterval(intervalId);
    }, [userEmail, dispatch, location]);

    // Get the highest user level
    let userRole = localStorage.getItem('rbac_role')?.toLowerCase();

    if (!userRole || userRole === undefined) {
        userRole = rbacGlobalData?.global_role;
    }

    if (!userRole || userRole === 'null') {
        try {
            // Get the highest user level
            const businessRoles = JSON.parse(localStorage.getItem('rbac_data')) || [];
            const rolePriority = ['technician', 'supervisor', 'admin', 'tla'];
            for (let i = rolePriority.length - 1; i >= 0; i--) {
                const match = businessRoles.find(b => b.role.toLowerCase() === rolePriority[i]);
                if (match) {
                    userRole = rolePriority[i];
                    localStorage.setItem('rbac_role', userRole);
                    break;
                }
            }
        } catch (e) {
            console.error('Error parsing rbac_data:', e);
            userRole = null;
        }
    }
    
    const menuItems = [
        { 
            id: 'health-info', 
            label: 'Health Info', 
            icon: <img src={HealthInfoIcon} alt='HealthInfoIcon'/>, 
            path: '/health',
        },
        { 
            id: 'report', 
            label: 'Reporting', 
            icon: <img src={ReportingIcon} alt='ReportingIcon'/>, 
            path: '/report' 
        },
        { 
            id: 'lifecycle', 
            label: 'Asset Lifecycle', 
            icon: <img src={LifecycleIcon} alt='LifecycleIcon'/>, 
            path: '/lifecycle' 
        },
        { 
            id: 'user-management', 
            label: 'User Management', 
            icon: <img src={UserManagementIcon} alt='UserManagementIcon'/>, 
            path: '/admin', 
            allowedRoles: ['tla', 'admin', 'supervisor'] 
        },
        {
            id: 'admin', 
            label: 'Admin', 
            icon: <img src={AdminIcon} alt='AdminIcon'/>,
            allowedRoles: ['tla', 'admin', 'supervisor', 'technician'], 
            submenu: [
                {
                    id: 'licenses',
                    label: 'Licenses',
                    icon: <img src={LicenseIcon} alt='LicenseIcon'/>,
                    path: '/licenses',
                },          
                // filter Sites inline
                ...(effectiveRole === 'tla' || effectiveRole === 'admin' 
                    ? [{
                    id: 'sites',
                    label: 'Sites',
                    icon: <img src={SiteIcon} alt='SiteIcon'/>,
                    path: '/sites',
                    }]
                    : []
                )
            ]
        },
        {
            id: 'resources', 
            label: 'Resources', 
            icon: <img src={ResourcesIcon} alt='ResourcesIcon'/>,
            submenu: [
                {
                    id: 'downloads-faq',
                    label: 'Downloads & FAQs',
                    icon: <i className="fa-solid fa-download" style={{color: "#ffffff"}}></i>,
                    path: '/faq',
                },
                {
                    id: 'videos',
                    label: 'Videos',
                    icon: <i className="fa-solid fa-video" style={{color: "#ffffff"}}></i>,
                    path: '/videos',
                }
            ]
        }
    ];

    // Card data array for easier management
    const cardData = [
        {
        image: Card1,
        text: card1Text,
        id: 'card1'
        },
        {
        image: Card2,
        text: card2Text,
        id: 'card2'
        }
    ];

    return (
        <SideBar 
            menuItems={menuItems} 
            logo={BRAND_LOGO}
            cardData={cardData}
            footerContent={<img src={FOOTER_LOGO} alt="footer-logo"/>}
            webUrl={webURL}
            userRole={userRole}
        />
    )
  
};

export default SideBarNew;